import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { UserService } from './shared/user.service';
import { SplashScreen } from '@capacitor/splash-screen';

import { App } from '@capacitor/app';
import { IonRouterOutlet, Platform } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet: IonRouterOutlet;
  // authenticated = false;
  user;
  constructor(
    private _userService: UserService,
    public _router: Router,
    private _autService: AuthService,
    private platform: Platform
  ) {
    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (!this.routerOutlet.canGoBack()) {
        App.exitApp();
      }
    });

    // document
    // .getElementsByTagName('html')[0]
    // .setAttribute('dir', 'rtl');
  }
  ngOnInit(): void {
    // Hide the splash (you should do this on app launch)
    // SplashScreen.hide();
    this._autService.isAuthenticated$.subscribe((state) => {
      // this.authenticated = state;
      if (state) {
        this._userService.user$.subscribe((user) => {
          this.user = user;
        });
      }
      // else {
      //   console.log(this._router.url);
      //   this._router.navigateByUrl('/login');
      // }
    });
  }

  onLogOut(): void {
    this._autService.signOut().subscribe();
  }
}
